import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left-chevron-blue",
  "use": "left-chevron-blue-usage",
  "viewBox": "0 0 6 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 6 11\" id=\"left-chevron-blue\"><path d=\"m2.147 5.5 3.478 3.82-1.073 1.18L0 5.5l4.552-5 1.073 1.18L2.147 5.5Z\" fill=\"#0076C0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol